import React, { useEffect, useState } from "react";
import NewLoadingCircle from "../../NewLoadingCircle";

const InvoiceSetupTable = ({ openFormForEdit }) => {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError]     = useState(false);

  useEffect(() => {
    // Simulate async fetch with a 1-sec delay
    const timer = setTimeout(() => {
      try {
        // For real usage, replace with an actual fetch/axios call:
        // e.g. const response = await axios.get("/api/invoice-setup");
        // setTableData(response.data);
        
        const mockData = [
          {
            id: 101,
            name: "Invoice Setup Person A",
            email: "personA@invoicesetup.com",
            companyType: "Invoicer",
            dobScrapeType: "Type A",
            companyName: "Invoice Solutions LLC",
            password: "•••••",
          },
          {
            id: 102,
            name: "Invoice Setup Person B",
            email: "personB@invoicesetup.com",
            companyType: "Invoicer",
            dobScrapeType: "Type B",
            companyName: "Billing Experts Inc",
            password: "•••••",
          },
        ];

        setTableData(mockData);
        setIsLoading(false);
      } catch (err) {
        console.error("Error loading InvoiceSetup data:", err);
        setIsError(true);
        setIsLoading(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Show spinner or error if needed
  if (isLoading || isError) {
    return (
      <NewLoadingCircle
        isLoading={isLoading}
        isError={isError}
        errorMessage="Failed to load Invoice Setup data."
      />
    );
  }

  // Otherwise, render table
  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Invoice Setup Table</h2>
      
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Company Type</th>
            <th className="px-4 py-2 text-left">DOB Scrape Type</th>
            <th className="px-4 py-2 text-left">Company Name</th>
            <th className="px-4 py-2 text-left">Password</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row) => (
            <tr
              key={row.id}
              className="border-b hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                if (openFormForEdit) {
                  openFormForEdit(row);
                }
              }}
            >
              <td className="px-4 py-2 text-blue-600 underline">{row.name}</td>
              <td className="px-4 py-2">{row.email}</td>
              <td className="px-4 py-2">{row.companyType}</td>
              <td className="px-4 py-2">{row.dobScrapeType}</td>
              <td className="px-4 py-2">{row.companyName}</td>
              <td className="px-4 py-2">{row.password}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceSetupTable;
